import script from "./personnel-query-popup.vue?vue&type=script&lang=ts&setup=true"
export * from "./personnel-query-popup.vue?vue&type=script&lang=ts&setup=true"

import "./personnel-query-popup.vue?vue&type=style&index=0&id=64e1ab54&scoped=true&lang=stylus"

import exportComponent from "/Users/yangwenqi/Desktop/蓝豚/web/pc-customer-admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-64e1ab54"]])

export default __exports__